export enum PaymentIntervalMonths {
  monthly = 1,
  yearly = 12,
}

export const convertToSmallestUnit = (amount: number, decimalPlaces = 2): number => {
  if (amount < 0) {
    return 0;
  }

  const factor = Math.pow(10, decimalPlaces);

  return Math.round(amount * factor);
};
